<!-- 轮播图Banner -->
<template>
  <van-swipe
    class="banner-div"
    :autoplay="data.show_time || 3000"
    indicator-color="white"
    @change="onSwipeChange"
  >
    <van-swipe-item v-for="(item, idx) in data.item" :key="idx">
      <div class="img-box">
        <img
          v-if="preparedImages.has(idx)"
          :src="$cvWebpFn(item.image, { w: 720 })"
          class="image"
          :loading="eager || priority || idx !== 0 ? 'eager' : 'lazy'"
          :fetchpriority="idx === 0 && priority ? 'high' : 'low'"
          @click="handleBannerClick(item)"
          @load="onImageLoad(idx)"
        >
        <div v-else class="image-placeholder">
          <van-loading size="24px" color="#1989fa" />
        </div>
      </div>
    </van-swipe-item>
  </van-swipe>
</template>

<script setup lang="ts">
import { getImageFileNameFromUrl } from '@/plugins/utils'

interface BannerItem {
  /** 图片地址URL */
  image: string
  /** 操作类型 */
  type: string
  /** 操作数据 */
  data: string
  /** Banner 名称（可选） */
  title?: string
}

interface BannerData {
  /** 自动轮播间隔毫秒 */
  show_time: number
  /** 轮播图配置项 */
  item: BannerItem[]
}

const props = withDefaults(
  defineProps<{
    data: BannerData
    /** 首页轮播：跳转时写入 Banner|centerBanner 埋点 source */
    trackHomeBannerSource?: boolean
    priority?: boolean
    eager?: boolean
  }>(),
  { trackHomeBannerSource: false, priority: false, eager: true }
)
// @ts-ignore
const { $cvWebpFn, $cmsGoTo } = useNuxtApp()

const handleBannerClick = (item: BannerItem) => {
  if (props.trackHomeBannerSource) {
    $cmsGoTo(item.type, item.data, {
      trafficSourceScene: 'homeCenterBanner',
      sourceValue: getImageFileNameFromUrl(item.image) || item.title || ''
    })
    return
  }
  $cmsGoTo(item.type, item.data)
}

const { preparedImages, prepareImages: onSwipeChange, onImageLoad } = useSwipeImageLoading(() => props.data.item)
</script>
<style lang='scss' scoped>
.banner-div {
  line-height: 0;
  background-color: white;
  .van-swipe-item {
    color: #fff;
    line-height: 0;
  }
}
.img-box{
  position: relative;
  height: 0;
  width: 100%;
  padding-bottom: 35.29%;
  .image{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    border-radius: 10px;
    overflow: hidden;
    height: 100%;
    width: 100%;
  }
  .image-placeholder {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    border-radius: 10px;
    background-color: #f5f5f5;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
  }
}
</style>
